var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24px",
    "data-name": "24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1221.944,115.249l-4.161-7.21V103.4h.2a.51.51,0,0,0,.511-.509v-.341a.512.512,0,0,0-.511-.512h-3.977a.511.511,0,0,0-.509.512v.341a.509.509,0,0,0,.509.509h.206v4.635l-4.163,7.21a.932.932,0,0,0,.807,1.4h10.279A.932.932,0,0,0,1221.944,115.249Zm-1.721.777h-8.451a.767.767,0,0,1-.664-1.149l1.645-2.849a2.412,2.412,0,0,0,1.455.157c.966-.413,1.061-1.089,2.5-1.3a4.739,4.739,0,0,1,2.115.418l2.062,3.571A.765.765,0,0,1,1220.223,116.026Z",
    transform: "translate(-1203.925 -97.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BoundingBox",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilders);
export default __webpack_public_path__ + "static/media/Builders.07209bf8.svg";
export { ForwardRef as ReactComponent };